customElements.define('custom-point', class extends HTMLElement {
  submitData = {};
  constructor() {
    super();
    this.customer = JSON.parse(this.getAttribute("data-customer") || "{}");
    this.customerInfo = {};

    this.currentPage = 1;
    this.totalPages = 0;

    this.handleGetPointHistory()
    this.handleGetPointSummary()
  }

  async handleGetPointSummary() {
    const url = window.middlewareUrls.pointSummary;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          shopId: this.customer.shopId,
          cstmIntgSeq: this.customer.cstmIntgSeq,
        })
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const resJson = await response.json();

      const pointValue = this.querySelector('.custom-points__value');
      pointValue.innerHTML = new Intl.NumberFormat().format(resJson.data.availablePoint) + "P";
      return resJson;
    } catch (error) {
      console.error(error.message);
    }
  }

  async handleGetPointHistory() {
    const url = window.middlewareUrls.pointList

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          shopId: this.customer.shopId,
          cstmIntgSeq: this.customer.cstmIntgSeq,
          page: "1",
        })
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const resJson = await response.json();
      const pointData = resJson.data.point_data;

      if (pointData && pointData.length) {
        this.totalPages = pointData[0].totPage;
        let tableData;
        let pagination;

        pointData.forEach((point) => {
          const date = this.formatDate(point?.date);
          const validPeriod = this.formatDate(point?.validPeriod);
          const formatPoint = new Intl.NumberFormat().format(point?.point);

          tableData = document.createElement('li');
          tableData.classList.add('mypage-list__item', 'table-data');
          tableData.innerHTML = `
            <dl class="mypage-list__details">
              <dt class="mypage-list__label">Nội dung</dt>
              <dd class="mypage-list__value">${point?.typeNM || ""}</dd>
            </dl>
  
            <dl class="mypage-list__details">
              <dt class="mypage-list__label">thưởng</dt>
              <dd class="mypage-list__value">
                <span class="custom-points__value-point">${formatPoint || ""}P</span>
              </dd>
            </dl>
  
            <dl class="mypage-list__details">
              <dt class="mypage-list__label">Ngày nhận điểm </dt>
              <dd class="mypage-list__value">${date || ""}</dd>
            </dl>
  
            <dl class="mypage-list__details">
              <dt class="mypage-list__label">Ngày hết hạn</dt>
              <dd class="mypage-list__value">${validPeriod || ""}</dd>
            </dl>
          `;
          this.querySelector('.mypage-list').appendChild(tableData);
        })

        pagination = document.createElement('div');
        pagination.classList.add('pagination');

        pagination.innerHTML = `
          <a href="#points-history" id="prev" class="disabled">&lt;</a>
          <a href="#points-history" id="next" class="disabled">&gt;</a>
        `;
        this.appendChild(pagination);

        if (pointData[0].totPage > 1) {
          for (let i = 0; i < pointData[0].totPage; i++) {
            const pages = document.createElement('a');
            pages.classList.add('page-link');

            if (i == 0) {
              pages.classList.add('active');
            }

            pages.setAttribute('data-page', (i + 1).toString());
            pages.setAttribute('href', '#');
            pages.innerHTML = (i + 1).toString();

            const next = this.querySelector('#next');
            next.classList.remove('disabled');
            pagination.insertBefore(pages, next);
          }

          const pageLinks = this.querySelectorAll('.page-link');
          pageLinks.forEach((link) => {
            link.addEventListener('click', (e) => {
              e.preventDefault();
              const page = parseInt(link.getAttribute('data-page'));
              if (page !== this.currentPage) {
                this.currentPage = page;
                this.updatePagination();
              }
            });
          });

          const prevButton = this.querySelector('#prev');
          const nextButton = this.querySelector('#next');

          prevButton.addEventListener('click', () => {
            if (this.currentPage > 1) {
              this.currentPage--;
              this.updatePagination();
            }
          });

          nextButton.addEventListener('click', () => {
            if (this.currentPage < this.totalPages) {
              this.currentPage++;
              this.updatePagination();
            }
          })
        } else {
          const page = document.createElement('a');
          page.classList.add('page-link', 'active');
          page.setAttribute('data-page', '1');
          page.setAttribute('href', '#');
          page.innerHTML = "1";

          const next = this.querySelector('#next');
          pagination.insertBefore(page, next);
        }
      }
      return resJson;
    } catch (error) {
      console.error(error.message);
    }
  }

  formatDate(date) {
    const formatDate = new Date(date);
    let day = formatDate.getDate();
    let month = formatDate.getMonth() + 1;
    const year = formatDate.getFullYear();

    if (day < 10) {
      day = '0' + day;
    }

    if (month < 10) {
      month = '0' + month;
    }

    return [day, month, year].join('.');
  }

  async updatePagination() {
    const url = window.middlewareUrls.pointList
    const pageLinks = this.querySelectorAll('.page-link');
    const prevButton = this.querySelector('#prev');
    const nextButton = this.querySelector('#next');

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          shopId: this.customer.shopId,
          cstmIntgSeq: this.customer.cstmIntgSeq,
          page: this.currentPage.toString(),
        })
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      prevButton.classList.toggle('disabled', this.totalPages <= 1 || (this.totalPages > 1 && this.currentPage === 1))
      nextButton.classList.toggle('disabled', this.totalPages <= 1 || (this.totalPages > 1 && this.currentPage === this.totalPages))

      pageLinks.forEach((link) => {
        const page = parseInt(link.getAttribute('data-page'));
        link.classList.toggle('active', page === this.currentPage);
      });

      const resJson = await response.json();
      const pointData = resJson.data.point_data;
      const tableData = this.querySelectorAll('.table-data');
      tableData.forEach(e => e.remove());

      if (pointData && pointData.length) {
        let newNode;

        pointData.forEach((point) => {
          const date = this.formatDate(point?.date);
          const validPeriod = this.formatDate(point?.validPeriod);
          const formatPoint = new Intl.NumberFormat().format(point?.point);

          newNode = document.createElement('li');
          newNode.classList.add('mypage-list__item', 'table-data');
          newNode.innerHTML = `
            <dl class="mypage-list__details">
              <dt class="mypage-list__label">Nội dung</dt>
              <dd class="mypage-list__value">${point?.typeNM || ""}</dd>
            </dl>

            <dl class="mypage-list__details">
              <dt class="mypage-list__label">thưởng</dt>
              <dd class="mypage-list__value">
                <span class="custom-points__value-point">${formatPoint || ""}P</span>
              </dd>
            </dl>

            <dl class="mypage-list__details">
              <dt class="mypage-list__label">Ngày nhận điểm </dt>
              <dd class="mypage-list__value">${date || ""}</dd>
            </dl>

            <dl class="mypage-list__details">
              <dt class="mypage-list__label">Ngày hết hạn</dt>
              <dd class="mypage-list__value">${validPeriod || ""}</dd>
            </dl>
          `;
          this.querySelector('.mypage-list').appendChild(newNode);
        })
      }

      return resJson;
    } catch (error) {
      console.error(error.message);
    }
  }
})